import React from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import {useNavigate} from "react-router-dom";
import './_static/Login.css';
import userImage from '../_images/person-square.svg';
import passwordImage from '../_images/lock-fill.svg';
import LoginButton from "../buttons/LoginButton";
import loginScreenImage from '../_images/login-screen.svg';
import {ModalProvider, useModal} from "../dialogs/ModalContext";
import PopupWarning from "../dialogs/PopupWarning";
import PopupError from "../dialogs/PopupError";
import {getAppName, useAxiosSetup} from "../Api";

function Login(props) {

    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const navigate = useNavigate()
    const {showModal} = useModal();
    const api = useAxiosSetup();

    function attemptLogin() {
        const url = "/api/token/"
        api.post(url, {username: username, password: password}, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then((response) => {
            // if (response.password_valid === true) {
            //     const token = response.token
            //     props.loginUser(token)
            // }
            const appName = getAppName()
            localStorage.setItem(`${appName}_refresh`, response.data.refresh)
            localStorage.setItem(`${appName}_access`, response.data.access)
            localStorage.setItem(`${appName}_admin`, response.data.admin)
            localStorage.setItem(`${appName}_user`, response.data.user)
            navigate('/')
        }).catch((error) => {
            if (error.response.status === 401) {
                showModal(PopupWarning, "Zlé meno alebo heslo", () => {
                })
            }
        })
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            attemptLogin();
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
            <div className="loginScreen align-middle">
                {/*<h1 className="d-flex justify-content-center">Prihlásenie</h1>*/}
                <div className="mb-5 d-flex justify-content-center">
                    <img className="align-middle" height="150" src={loginScreenImage}/>
                </div>
                <div className="d-flex">
                    <img className="loginImage" src={userImage}/>
                    <InputGroup className="mb-3">
                        <Form.Control name={props.name} onChange={(event) => setUsername(event.target.value)}
                                      value={username} onKeyDown={handleKeyPress}/>
                    </InputGroup>
                </div>
                <div className="d-flex">
                    <img className="loginImage" src={passwordImage}/>
                    <InputGroup className="mb-3">
                        <Form.Control type="password" name={props.name}
                                      onChange={(event) => setPassword(event.target.value)}
                                      value={password} onKeyDown={handleKeyPress}/>
                    </InputGroup>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                    <LoginButton onClick={attemptLogin}/>
                </div>
                {/*<div>*/}
                {/*    <button type="button" className="btn btn-info">Zmena hesla</button>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

export default Login
